class BESSAppProjectProfiler extends BESSAppBase {

    constructor(data) {
        super();
        this.data = new BESSAppProjectProfilerData(data);
        this.identifier = this.data.editorId;
        this.title = this.data.title;
        this.inlineEditor = null;
        this.hasItems = null;
        this.#setupView();
        this.manager = this.#createManager();
    }

    static #profilerMap = null;


    #createManager() {

        if (BESSAppProjectProfiler.#profilerMap == null) {
            BESSAppProjectProfiler.#profilerMap = {
                'BESSAppProjectDetailsEditor': BESSAppProjectDetailsProfilerManager,
                'ResDwellingsEditor': BESSAppProjectDwellingsProfilerManager,
                'NonResDwellingsEditor': BESSAppProjectDwellingsProfilerManager,
                'DaylightEditor': BESSAppDaylightProfilerManager,
                'InitiativesEditor': BESSAppProjectInitiativesProfilerManager,
                'IWMWaterSpaceEditor': BESSAppProjectIWMWaterSpaceProfilerManager,
            };
        }

        let managerType = nullIfUndefined(BESSAppProjectProfiler.#profilerMap[this.data.editorId]);
        if (managerType != null) {
            return new managerType(this);
        }
        return null;
    }

    start() {
        if (this.inlineEditor != null) {
            this.inlineEditor.start();
        }
        this.forEach(this.items, function (item) {
            item.start();
        });
        if (this.manager != null) {
            this.manager.start();
        }
        this.#fireHasItemsEvent();
    }

    update(profilerData) {
        this.data = new BESSAppProjectProfilerData(profilerData.data);
        this.title = this.data.title;
        this.updateViewContents(profilerData.view);
        this.start();
    }

    updateViewContents(contents) {
        this.views.root.replaceWith(contents);
        this.#setupView();
        BESSAppComponent.initialiseFor(this.views.root);
    }


    showTotals(totalsContent) {
        this.views.viewTotals.html(totalsContent);
        this.views.viewTotals.show();
    }

    #onAddItem() {
        this.log("onAddItem");
        new BESSAppProjectEditorModal(this).openAndAddNewItem();
    }

    #onEditItem() {
        this.log("onEditItem");
        new BESSAppProjectEditorModal(this).open();
    }

    #setupView() {
        let profilerId = 'app-profiler-' + this.identifier.replace('/', '\\/');
        let root = $('#' + profilerId);
        if (root.hasClass('app-profiler-count')) {
            let index = root.parent().find('.app-profiler-count').index(root);
            root.addClass('app-profiler-' + (index + 1));
        }
        this.views = {
            root: root,
            addItemButton: root.find('.app-action-add-item'),
            editButton: root.find('.app-action-edit-main'),
            items: root.find('.app-profiler-item'),
            nav: $('.app-section-nav[data-nav-id="' + profilerId + '"]'),
            viewTotals: root.find('.app-profiler-totals'),
        }
        this.items = _.map(this.views.items,
            function (node, index) {
                return new BESSAppProjectProfilerItem(this, $(node), this.data.items[index], this.data.fields);
            }.bind(this));

        this.views.addItemButton.bindClickEvent(this, this.#onAddItem);
        this.views.editButton.bindClickEvent(this, this.#onEditItem);
        this.views.viewTotals.hide();

        if (this.views.root.hasClass('app-profiler-editable')) {
            this.inlineEditor = new BESSAppProjectInlineEditor(this);
        }

        new BESSAppDependentView(this.views.root.add(this.views.nav), this.data.dependencies);
    }

    #fireHasItemsEvent() {
        let hasItems = this.data.items.length > 0 || this.views.root.hasClass('hidden');
        if (this.hasItems === null || this.hasItems !== hasItems) {
            let changed = this.hasItems != null;
            this.hasItems = hasItems;
            this.fireEvent(new BESSAppHasItemsDependencyEvent(this.data.editorId, this.hasItems, changed), !changed);
        }
    }
}
